// Weathervane rooster — bespoke logo (pure-black silhouette, transparent bg).
const LOGO_URL = "/weathervane_logo.png";

export default function RoosterLogo({ className = "", size = 56 }) {
  return (
    <img
      src={LOGO_URL}
      alt="Weathervane logo"
      width={size}
      height={size}
      className={className}
      style={{ display: "inline-block", objectFit: "contain" }}
      data-testid="rooster-logo"
    />
  );
}
